var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M5.49996 9H3.16663C2.3382 9 1.66663 9.67157 1.66663 10.5V12.8333C1.66663 13.6618 2.3382 14.3333 3.16663 14.3333H5.49996C6.32839 14.3333 6.99996 13.6618 6.99996 12.8333V10.5C6.99996 9.67157 6.32839 9 5.49996 9Z",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M5.49996 1.66667H3.16663C2.3382 1.66667 1.66663 2.33824 1.66663 3.16667V5.50001C1.66663 6.32843 2.3382 7.00001 3.16663 7.00001H5.49996C6.32839 7.00001 6.99996 6.32843 6.99996 5.50001V3.16667C6.99996 2.33824 6.32839 1.66667 5.49996 1.66667Z",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M12.8333 1.66667H10.5C9.67157 1.66667 9 2.33824 9 3.16667V5.50001C9 6.32843 9.67157 7.00001 10.5 7.00001H12.8333C13.6618 7.00001 14.3333 6.32843 14.3333 5.50001V3.16667C14.3333 2.33824 13.6618 1.66667 12.8333 1.66667Z",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M11.6667 9.5V13.8333M13.8333 11.6667H9.5",
  stroke: "#000",
  strokeLinecap: "round"
}))));

export default __webpack_public_path__ + "static/media/Dashboard.0f906fab.svg";
export { SvgComponent as ReactComponent };